module.exports = __webpack_public_path__ + "img/comment-icon.c2af7d1a.svg";